/* tslint:disable */
import { Coordinates } from './coordinates';

/**
 */
export class TemperatureProfileData {
    top?: Coordinates;
    bottom?: Coordinates;
    left?: Coordinates;
    right?: Coordinates;
    front?: Coordinates;
    rear?: Coordinates;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temperature-profile-data.ts